import { hyperspaceSectionalRestoreAttemptsFamily } from '@/components/ui/choose-note-structure-modal/choose-note-structure-command/atoms';
import { getDefaultStore } from 'jotai';
import { RESET } from 'jotai/utils';

const jotaiStore = getDefaultStore();

/** Call only behind the body's existing surface/arm guards. */
export function resetSectionalRestoreAttempts(sessionId: string): void {
  jotaiStore.set(hyperspaceSectionalRestoreAttemptsFamily(sessionId), RESET);
}

/** The caller owns the cap check and any failure toast. */
export function recordSectionalRestoreAttempt(sessionId: string, next: number): void {
  jotaiStore.set(hyperspaceSectionalRestoreAttemptsFamily(sessionId), next);
}
